export const formatNameToScopeId = (name) => {
  if (!name) return "";
  const cleaned = name
    .normalize("NFKC")
    .trim()
    // Replace any sequence of space characters (including non‑breaking / bidi spaces) with a single ASCII space
    .replace(/\s+/gu, " ")
    .toLowerCase()
    // Replace spaces and dots with dashes
    .replace(/[.\s]+/g, "-")
    // Remove any character that is not a letter (any language), number, dash, or underscore
    .replace(/[^\p{L}\p{N}_-]+/gu, "")
    // Collapse multiple dashes
    .replace(/-+/g, "-")
    // Trim leading/trailing dashes
    .replace(/^-|-$/g, "");

  return cleaned;
};
